var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fas",class:_vm.iconClass,attrs:{"title":_vm.titleText}})
}
var staticRenderFns = []

export { render, staticRenderFns }